import { Site } from '@envato/foundation-types'
import * as React from 'react'

import ui from '../../common/constants/ui'
import { siteAbbreviations } from '../../common/constants/siteAbbreviations'
import EnhancedLazyLoad from './enhancedLazyLoad'

const redirectUrl = (site: Site) => {
  if (siteAbbreviations[site]) {
    return `https://elements.envato.com/all-items/?utm_campaign=elements_mkt-search_26JUNE2017&utm_content=${
      siteAbbreviations[site]
    }_search-results&utm_medium=promos&utm_source=${site}.net`
  } else {
    return 'https://elements.envato.com/all-items'
  }
}

interface IProps {
  currentSite: Site
}

const assetsUrl = 'https://public-assets.envato-static.com'

const imageUrl =
  '/assets/cross-promos/girl-with-headphones-f811be66c897e4e8d9243e07b77c3745eef05c9ab0862c903d1a88e794ce74c6.png'

const logoUrl =
  '/assets/header/EnvatoElements-logo-white-9da0fc69f9b86a09858bef5144a4024838fa91bec3701e299fd36735da7331ee.svg'

const ElementsBanner = ({ currentSite }: IProps) => (
  <div className="elements-promo">
    <div className="elements-promo__copy-wrapper">
      <div className="elements-promo__content">
        <EnhancedLazyLoad height="100%" once offset={ui.lazyLoadOffset}>
          <img
            alt="Envato Elements"
            className="elements-promo__logo-white"
            src={assetsUrl + logoUrl}
          />
        </EnhancedLazyLoad>
        <h2 className="elements-heading fds-c-text-heading -size-l fds-u-mb0">
          Deliver better projects faster
        </h2>
        <p className="elements-heading fds-c-text-body fds-u-mb0">
          Unlimited photos, web templates, graphic assets &amp; courses.
        </p>
        <div className="elements-promo__button-wrapper">
          <a className="elements-promo__button" href={redirectUrl(currentSite)}>
            View all
          </a>
        </div>
      </div>
      <EnhancedLazyLoad height="100%" once offset={ui.lazyLoadOffset}>
        <img
          aria-hidden="true"
          className="elements-promo__image"
          src={assetsUrl + imageUrl}
          alt="Girl with headphones"
        />
      </EnhancedLazyLoad>
    </div>
  </div>
)

export default ElementsBanner
